import { useContext, useState } from 'react';
import axios from 'axios';
import { tokenContext } from '../componentes/TokenContext';

export const useServices = () => {

    const { token } = useContext(tokenContext);
    // const [consultaPay, setConsultaPay] = useState({
    //     loaded:false,
    //     consulta: null,
    //     error:null,
    // });

    const getTakito = () => {
        const rumpelstinki = {
            "urombrett": "pibe4353fdas",
            "contwyerr": "engyr533hrr5"
        }

        let result = axios.post(`/ohaurlisrp/nteragyuytil/`, rumpelstinki)
            .then(response => {
                return response.data;
            })
            .catch((error) => {

                return error.response;
            });
        //console.log('topuptkServices: ', result);
        return result;
    }

    //Servicios StoreLocator
    const getEdos = async () => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": "storelocator/estados"
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const getMun = async (id) => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": `storelocator/municipios/${id}`
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const getCol = async (id) => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": `storelocator/colonias/${id}`
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const getTiendas = async (id) => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": `storelocator/tiendas/${id}?number_row=10`
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const getTiendasHaversine = async (lat, lgn) => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": `storelocator/tiendas/haversine/${lat}/${lgn}?distance=2&number_row=10`
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    //Servicios Activacion Ofertas

    const activaSas = async (payload) => {
        const tk = await getTakito();
        const request = {
            ...payload,
            "token": token,
        }
        const apiRequest = {
            "method": "POST",
            "path": `promotion/activateSAS`,
            "request": request
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, apiRequest, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const activaKairos = async (payload) => {
        const tk = await getTakito();
        const request = {
            ...payload,
            "trigger": "235",
            "token": token,
        }
        const apiRequest = {
            "method": "POST",
            "path": `promotion/activateKairos`,
            "request": request
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, apiRequest, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };
    //////Consulta en servicio

    const getConsulta = async () => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": `promotion/consultOffer/${token}`
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    ///Servicios Payment



    const getBotonPago = async () => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": `parameter/enablePayment/${token}`
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, request, config)

            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };



    const guardarDatosPay = async (payload) => {
        const tk = await getTakito();
        const request = {
            ...payload,
            "token": token
        }
        const apiRequest = {
            "method": "POST",
            "path": `payment/bitacora/`,
            "request": request
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, apiRequest, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const getCredenciales = async () => {
        const tk = await getTakito();
        const request = {
            "method": "POST"
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`api/payment/credenciales`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    }

    const getToken = (payload, url) => {
        const postData = {
            ...payload
        };
        // console.log('Request JWT: ', postData)
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Accept": "application/json"
            }
        };
        const url1 = url

        //console.log('url webToken: ', url1);

        let result = axios.post(url, postData, axiosConfig)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const getCODI = async (id) => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": `parameter/${id}`
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };

        let result = axios.post(`/webservice/goapimicrositio`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const getPago = async (id) => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": `parameter/${id}`
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };

        let result = axios.post(`/webservice/goapimicrositio`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const guardaDataPay = async (payload) => {
        const tk = await getTakito();
        const request = {
            "method": "PUT",
            "path": `payment/bitacora`,
            "request": payload
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };

        let result = axios.post(`/webservice/goapimicrositio`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const validateDn = async (dn, canal) => {
        const tk = await getTakito();
        const request = {
            "method": "GET",
            "path": `recharges/validateDn?channel=${canal}&mdn=${dn}`
        }

        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, request, config)

            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };

    const validateSuperMontos = async (payload) => {
        const tk = await getTakito();
        const request = {
            ...payload
        }
        const apiRequest = {
            "method": "POST",
            "path": `recharges/getMontoRecargas`,
            "request": request
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, apiRequest, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };


    const getExtId = async (dn, cantidad, pay) => {
        const tk = await getTakito();
        const apiRequest = {
            "method": "POST",
            "path": `recharge/bitacora?mdn=${dn}&amount=${cantidad}&paymenttype=${pay}`
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, apiRequest, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };


    const guardaBitacora = async (payload) => {
        const tk = await getTakito();
        const request = {
            "method": "PUT",
            "path": `recharge/bitacora`,
            "request": payload
        }
        const config = {
            headers: { Authorization: `Bearer ${tk}` }
        };
        let result = axios.post(`/webservice/goapimicrositio`, request, config)
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                return error.response;
            });
        return result;
    };



    return {
        getEdos,
        getMun,
        getCol,
        getTiendas,
        getTiendasHaversine,
        activaSas,
        activaKairos,
        guardarDatosPay,
        getCredenciales,
        getToken,
        guardaDataPay,
        getConsulta,
        getBotonPago,
        getCODI,
        validateDn,
        validateSuperMontos,
        getExtId,
        guardaBitacora,
        getPago
    }
}
